import React from 'react';
import PropTypes from 'prop-types';
import Graph from './Graph';
import apiClient from 'clients/apiClient';
import configHelper from 'helpers/config';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const TitleField = styled.div`
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 15px;
`;

const StyledTable = styled.table`
    border-collapse: collapse;
    width: 100%;
    text-align: center;
    float: left;
`;

const StyledTableHead = styled.thead`
    background-color: #f2f2f2;
    padding: 20px;
    font-weight: bold;
`;

const StyledTd = styled.td`
    padding: 17px;
`;

const StyledTr = styled.tr`
    :nth-child(even) {background-color: #f2f2f2}
`;

class CampaignBookingsGraph extends React.Component {
    constructor() {
        super();

        this.state = {
            isLoading: true,
            data: [],
        };
    }

    componentDidMount() {
        const { id } = this.props;

        const baseParams = {
            'base': 'created_at',
            'interval': 'week',
            'size': 12,
            'filters': {
                'reservation_status': [
                    'completed',
                ],
                'is_test_order': 0,
                'funnel_id': id,
            },
        };

        // Default url
        const url = `${ configHelper.getApiBaseUrl() }/statistics/bookings`;

        return apiClient.read(url, baseParams).then((response) => {
            const result = [];

            const amountOfWeeks = 6;

            for (let index = 0; index < amountOfWeeks; index++) {
                const { values, label } = response[index];

                const amount = values.reduce((amount, current) => {
                    return amount + current.amount;
                }, 0);

                result.push({
                    label: label,
                    amount: amount,
                });
            }

            this.setState({
                data: result,
            });
        });
    }

    render() {
        const { data } = this.state;
        const { translate } = this.props;

        if (utils.isEmpty(data)) {
            return null;
        }

        return (
            <div style={ { display: 'inline-flex', padding: '10px' } }>
                <Graph
                    data={ data }
                />

                <div style={ {
                    margin: '0 0 0 20px',
                    width: '50%',
                } }>
                    <TitleField>
                        { translate('resources.campaigns.show.last_week') }
                    </TitleField>
                    <StyledTable>
                        <StyledTableHead>
                            <StyledTr>
                                <StyledTd>
                                    { translate('resources.campaigns.show.week_number') }
                                </StyledTd>
                                <StyledTd>
                                    { translate('resources.campaigns.show.bookings_amount') }
                                </StyledTd>
                            </StyledTr>
                        </StyledTableHead>
                        <tbody>
                            {
                                <StyledTr key={ data.label } >
                                    <StyledTd>{ 'Current Week' }</StyledTd>

                                    <StyledTd>{ data[0].amount }</StyledTd>
                                </StyledTr>
                            }
                            {
                                data.map((element) => {
                                    if (element === data[0]) {
                                        return;
                                    }
                                    return (
                                        <StyledTr key={ element.label } >
                                            <StyledTd>{ `${ translate('resources.campaigns.show.week') } ${ element.label.split('#')[1] }` }</StyledTd>

                                            <StyledTd>{ element.amount }</StyledTd>
                                        </StyledTr>
                                    );
                                })
                            }
                        </tbody>
                    </StyledTable>
                </div>
            </div>
        );
    }
}

CampaignBookingsGraph.propTypes = {
    id: PropTypes.number,
    translate: PropTypes.func.isRequired,
};

export default translate(CampaignBookingsGraph);



// WEBPACK FOOTER //
// ./src/pages/campaigns/show/CampaignBookingsGraph.js